import React from "react";

import styled from "styled-components/macro";

import { NavLink, useParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

import {
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";

import { BpBrokers } from "../../services";

const Box = styled(MuiBox)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

export const BrokersRouletteLogsPage = () => {
  const [broker, setBroker] = React.useState(null);

  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState([]);

  const { brokerId } = useParams();

  React.useEffect(() => {
    (async () => {
      const resBroker = await BpBrokers.getById(brokerId);
      setBroker(resBroker.data);
    })();
  }, [brokerId]);

  React.useEffect(() => {
    (async () => {
      const resList = await BpBrokers.listLogs(brokerId, page);
      setData(resList.data);
    })();
  }, [brokerId, page]);

  return (
    <Box p={8}>
      <Helmet title="Roleta Virtual" />

      <Grid justify="space-between" container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Lista de Roletas Sorteadas
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/bp/brokers">
              Corretores
            </Link>
            <Link component={NavLink} exact to={`/bp/brokers/${brokerId}/edit`}>
              {broker?.name}
            </Link>
            <Typography>Roleta Logs</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <div>
            <Paper>
              <TableContainer>
                <Table aria-labelledby="tableTitle" size={"medium"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>EMPREENDIMENTO</TableCell>
                      <TableCell>PROTOCOLO</TableCell>
                      <TableCell>SORTEADO EM</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.rows?.map((row, index) => {
                      return (
                        <TableRow>
                          <TableCell align="left" id={index} scope="row">
                            <strong>{row.project.name}</strong>
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.protocol}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            <Box>
                              <Box>
                                {format(
                                  parseISO(row.createdAt),
                                  "PPPP 'às' p",
                                  {
                                    locale: pt,
                                  }
                                )}
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                labelDisplayedRows={({ from, to, count }) =>
                  `Página ${page + 1} de ${Math.ceil(count / 6)}`
                }
                rowsPerPageOptions={[6]}
                component="div"
                count={data.count || 0}
                rowsPerPage={6}
                page={page}
                onChangePage={(_, page) => setPage(page)}
              />
            </Paper>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
